import { CHAT_SETTINGS_QUERY_KEY } from "@frontend-shared/constants";
import { useQuery } from "@tanstack/react-query";

import { projectApi } from "@/api/services";

export const useChatSettings = (enabled: boolean) => {
  return useQuery({
    queryKey: [CHAT_SETTINGS_QUERY_KEY],
    queryFn: async () => projectApi.getProjectChatSettings(),
    enabled,
    // NOTE: AuthProvider holds the app on its loader while this query has no
    // data. A failed read must not be refetched by every component that
    // mounts afterwards (the chat page does), or the refetch brings the
    // loader back, unmounts that component and remounts it — a render loop.
    // A query that has data still refetches on mount as usual.
    retryOnMount: false,
  });
};
